import { createStyles } from '@mantine/core'

type StylesParams = {
  isPink?: boolean
}

export default createStyles((theme, { isPink }: StylesParams) => {
  return {
    root: {},
    inner: {
      width: 80,
      height: 80,
      borderRadius: '50%',
      background: isPink ? theme.colors.pink[0] : theme.colors.blue[0],
      [theme.fn.largerThan('sm')]: {
        width: 168,
        height: 168,
      },
    },
    wrapper: {
      maxWidth: 42,
      maxHeight: 42,
      [theme.fn.largerThan('sm')]: {
        maxWidth: 88,
        maxHeight: 88,
      },
    },
  }
})
